import { render, staticRenderFns } from "./MobBottomNav.vue?vue&type=template&id=35c9e182&scoped=true"
import script from "./MobBottomNav.vue?vue&type=script&lang=js"
export * from "./MobBottomNav.vue?vue&type=script&lang=js"
import style0 from "./MobBottomNav.vue?vue&type=style&index=0&id=35c9e182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c9e182",
  null
  
)

export default component.exports